import _classCallCheck from 'babel-runtime/helpers/classCallCheck';
import _createClass from 'babel-runtime/helpers/createClass';
import _possibleConstructorReturn from 'babel-runtime/helpers/possibleConstructorReturn';
import _inherits from 'babel-runtime/helpers/inherits';
import NebulaModuleBase from './module-base';
export var UPDiscoverDevicePlugin = function (_NebulaModuleBase) {
    _inherits(UPDiscoverDevicePlugin, _NebulaModuleBase);

    function UPDiscoverDevicePlugin() {
        _classCallCheck(this, UPDiscoverDevicePlugin);

        return _possibleConstructorReturn(this, (UPDiscoverDevicePlugin.__proto__ || Object.getPrototypeOf(UPDiscoverDevicePlugin)).apply(this, arguments));
    }

    _createClass(UPDiscoverDevicePlugin, [{
        key: 'getDiscoverDevInfoWithDisSearchInfo',
        value: function getDiscoverDevInfoWithDisSearchInfo(discoverSearchInfo) {
            return this.generatePromiseByFunctionWithParams('GetDevInfoForDiscoverPlugin', discoverSearchInfo);
        }
    }, {
        key: 'startScan',
        value: function startScan() {
            return this.generatePromiseByFunctionWithParams('StartScanForDiscoverPlugin', null);
        }
    }, {
        key: 'addDeviceSearchListener',
        value: function addDeviceSearchListener(listener) {
            var event = 'onDiscoverDeviceChange';
            var params = {
                eventName: event
            };
            return this.generatePromiseByAttachListenerWithParams(event, listener, 'AddListenerForDiscoverPlugin', params);
        }
    }, {
        key: 'removeDeviceSearchListener',
        value: function removeDeviceSearchListener(listener) {
            var event = 'onDiscoverDeviceChange';
            var params = {
                eventName: event
            };
            return this.generatePromiseByDetachListenerWithParams(event, listener, 'RemoveListenerForDiscoverPlugin', params);
        }
    }]);

    return UPDiscoverDevicePlugin;
}(NebulaModuleBase);